import { useEffect } from 'react';
import { useAppDispatch } from 'features/store/hooks';
import { getAssetNamespace } from '../utils/getAssetNamespace';
import { requireNamespaces } from './store/dynamicTranslationSlice';

// Declares the active asset's translation namespace as required so the
// DynamicTranslationProvider loads it. requireNamespaces REPLACES the array, so
// switching the active participation swaps the loaded namespace.
export const useRequireAssetNamespace = (assetId: string | undefined): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(requireNamespaces(assetId ? [getAssetNamespace(assetId)] : []));
  }, [dispatch, assetId]);

  // Reset when leaving participation routes (the hook unmounts) so a later
  // participation does not transiently reload the previous asset's namespace.
  // Stable `dispatch` deps keep this an unmount-only cleanup, leaving the
  // assetId-swap path above untouched.
  useEffect(
    () => () => {
      dispatch(requireNamespaces([]));
    },
    [dispatch]
  );
};
